/**
 * On scroll start to hide the logo
 */
$(window).scroll(function() {
  var scrollTop = $(this).scrollTop();

  $('#as-main-header').css({
    opacity: function() {
      var elementHeight = $(this).height() * 3.5;
      return (elementHeight - scrollTop) / elementHeight;
    }
  });
});
